import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "report" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    d: "M10.125 14.5H9.25C9 14.5 8.75 14.75 8.75 15V17.75C8.75 18 9 18.25 9.25 18.25H10.125C10.375 18.25 10.625 18 10.625 17.75V15C10.625 14.75 10.375 14.5 10.125 14.5V14.5ZM12.9375 12H12.0625C11.8125 12 11.5625 12.25 11.5625 12.5V17.75C11.5625 18 11.8125 18.25 12.0625 18.25H12.9375C13.1875 18.25 13.4375 18 13.4375 17.75V12.5C13.4375 12.25 13.1875 12 12.9375 12ZM14.875 18.25H15.75C16 18.25 16.25 18 16.25 17.75V13.75C16.25 13.5 16 13.25 15.75 13.25H14.875C14.625 13.25 14.375 13.5 14.375 13.75V17.75C14.375 18 14.625 18.25 14.875 18.25V18.25ZM19.4465 5.82734L16.1695 2.55078C15.818 2.19922 15.3414 2 14.8457 2H6.87461C5.83984 2.00391 5 2.84375 5 3.87852V20.1254C5 21.1602 5.83984 22 6.87461 22H18.1223C19.1574 22 20 21.1602 20 20.1254V7.15508C20 6.65938 19.798 6.17891 19.4465 5.82734V5.82734ZM14.998 4.03086L17.9703 7.00273H14.998V4.03086V4.03086ZM18.125 20.1254H6.87461V3.87852H13.1234V7.94023C13.1234 8.45977 13.5414 8.87734 14.0609 8.87734H18.125V20.1254Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }